import { createContext } from 'react';

const sessionContext = createContext();

export default sessionContext;